import React from 'react'
import { Card, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import NoDataAvailable from '../../components/NoDataAvailable'
import Loader from '../../components/Loader'
import usePromotion from './hooks/usePromotion'
import './styles/index.scss'
import HtmlParser from 'react-html-parser'
import Banner from '../../components/Banner'
import Icon from 'icons/Icon'
import Button from 'components/Common/Button'
import { BUTTON_VARIANT } from 'utils/constants'

const Promotions = () => {
  const {
    allBonus,
    loading,
    limit,
    languageData,
    selectedLanguageCode,
    bannerLoading,
    navigate,
    setLimit,
    capitalize
  } = usePromotion()

  return (
    <div className='promotions-page'>
      <section
        className='main-container-wrapper wrapper-content banner view-all-bonuses'
        id={loading ? 'height-70vh' : ''}
      >
        <div className='promotion-banner'>
          {loading
            ? (
              <Loader top='40vh' />
              )
            : (
              <>
                {!bannerLoading && <Banner pageType='promotions' />}
              </>
              )}
        </div>
      </section>
      <div className='main-container-wrapper-inner'>
        <section className='prom-tab-section promotion-wrap promotion-page'>
          <div className='prmotion-heading'>{languageData?.prmotionHeading}</div>
          <div className='wrapper'>
            <div className='promotion-container ml-0 mr-0'>
              <>
                {allBonus?.rows?.map((item, i) => (
                  <div
                    key={`bonus listing ${i}`}
                  >
                    <Card className='promotion_card'>
                      <div className='card_img_box'>
                        <Card.Img
                          src={item.imageUrl}
                          alt='Bonus Image'
                          className='card_img img-fluid'
                        />
                      </div>
                      <Card.Body>
                        <Card.Title className='mb-2 d-flex justify-content-start text-capitalize'>
                          <OverlayTrigger
                            overlay={(props) => (
                              <Tooltip {...props}>
                                {languageData[capitalize(item.bonusType)?.toUpperCase()]}
                              </Tooltip>
                            )}
                            placement='top'
                          >
                            <div
                              style={{
                                maxWidth: '100%',
                                cursor: 'pointer'
                              }}
                              className='d-inline-block'
                            >
                              <Icon name='tag' className='mr-1' width='14' height='14' />
                              {languageData[capitalize(item.bonusType)?.toUpperCase()]}
                            </div>
                          </OverlayTrigger>
                        </Card.Title>
                        <Card.Text
                          className='mb-2'
                          style={{ lineHeight: '26px' }}
                        >
                          <OverlayTrigger
                            overlay={(props) => (
                              <Tooltip {...props}>
                                <span
                                  style={{
                                    maxWidth: '100%',
                                    cursor: 'pointer'
                                  }}
                                  className='d-inline-block'
                                >
                                  {(
                                    item?.promotionTitle?.[
                                    selectedLanguageCode
                                    ] || item?.promotionTitle?.EN
                                  )?.toLowerCase()}
                                </span>
                              </Tooltip>
                            )}
                            placement='top'
                          >
                            <span
                              style={{
                                maxWidth: '100%',
                                cursor: 'pointer'
                              }}
                              className='d-inline-block text-capitalize fw-bold'
                            >
                              {(
                                item?.promotionTitle?.[
                                selectedLanguageCode
                                ] || item?.promotionTitle?.EN
                              )?.toLowerCase()}
                            </span>
                          </OverlayTrigger>
                        </Card.Text>
                        <p className='subtext mt-4'>
                          <span className='text-truncate promo-description'>
                            {item?.promotionalOverview?.[
                              selectedLanguageCode
                            ] || item?.promotionalOverview?.EN
                              ? HtmlParser(
                                (
                                  item?.promotionalOverview?.[
                                  selectedLanguageCode
                                  ] || item?.promotionalOverview?.EN
                                )
                                  .replaceAll('&nbsp;', ' ')
                                  .replaceAll('<p><br></p>', '')
                              )
                              : (item?.description?.[
                                selectedLanguageCode
                              ] ||
                                item?.description?.EN) &&
                              HtmlParser(
                                (
                                  item?.description?.[
                                  selectedLanguageCode
                                  ] || item?.description?.EN
                                )
                                  .replaceAll('&nbsp;', ' ')
                                  .replaceAll('<p><br></p>', '')
                              )}
                          </span>
                        </p>

                        <Button
                          variant={BUTTON_VARIANT.PRIMARY}
                          className='btn-primary-promotion btn-hover-effect'
                          onClick={() => {
                            navigate(
                              `/${selectedLanguageCode?.toLowerCase()}/promotion/${item?.other?.slug || item.bonusId
                              }`
                            )
                            window?.scrollTo(0, 0)
                          }}
                        >
                          {languageData?.promReadMore}
                        </Button>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
                {allBonus?.count === 0 && (
                  <Col className='no-promotions'>
                    <NoDataAvailable
                      errorMessage={languageData?.noPromotions}
                    />
                  </Col>
                )}
              </>
            </div>
            {allBonus?.count > limit && (
              <Button
                variant={BUTTON_VARIANT.PRIMARY}
                className='view-more btn-hover-effect'
                onClick={() => setLimit((prev) => prev * 2)}
              >
                {languageData?.viewMore}
              </Button>
            )}
          </div>
        </section>
      </div>
    </div>
  )
}

export default Promotions
